"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheArtOfNaming() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="the-art-of-naming" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(var(--color-border) 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10 flex justify-center">
        <div ref={ref} className={`max-w-[800px] w-full flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="w-16 h-1 bg-secondary mb-8 rounded-full" aria-hidden="true" />

          {}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-10 tracking-tight">
            The Art of Naming
          </h2>

          {}
          <div className="space-y-8 text-xl leading-relaxed text-foreground/90 font-sans">
            <p>
              Choosing a name is more than a simple decision; it is the first gift you give, a lifelong melody, and a cornerstone of identity. It is a word that will be whispered in lullabies, called out across playgrounds, and signed on the dotted lines of future achievements.
            </p>
            <p>
              At NamesOfTheWorld.com, we believe that every name carries a story, a heritage, and a unique resonance. We move beyond the conventional, curating collections that speak to modern sensibilities while honoring timeless traditions. Our approach is rooted in clarity, elegance, and a deep appreciation for the linguistic beauty found across cultures.
            </p>
            <p>
              Whether you seek a moniker that is boldly unique, deeply rooted in history, or currently capturing hearts, our meticulously organized directories are designed to inspire and guide you on this profound journey. Discover a name that doesn't just sound beautiful, but feels entirely right.
            </p>
          </div>
        </div>
      </div>
    </section>;
}